import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import styled from "styled-components";

const OrderDetailInfo = ({
  expand,
  modelCode,
  collectionCode,
  configuration,
  order,
  collection,
  line,
}) => {
  const lang = localStorage.getItem("B2BLanguage") == "ITA" ? "it" : "en";

  const OrderDetailText = styled.strong`
    display: inline-block;
    margin-bottom: 15px;
  `;
  return (
    <Flex
      flex={1}
      sx={{
        fontSize: "1.1em",
        color: "#232323",
      }}
      style={{
        position: "relative",
        cursor: "pointer",
      }}
      flexDirection={["column", , , "row"]}
      pt={["25px", , , 0]}
      justifyContent={"left"}
      alignContent={"center"}
      onClick={expand}
    >
      <Flex
        width={1}
        flexDirection="column"
        justifyContent="left"
        alignContent="center"
        style={{ display: "grid" }}
      >
        <Box>
          {getLocalizedString("Codice modello")}:{" "}
          <OrderDetailText>{modelCode}</OrderDetailText>
        </Box>
        <Box>
          {getLocalizedString("Codice collezione")}:{" "}
          <OrderDetailText>{collectionCode}</OrderDetailText>
        </Box>
      </Flex>
      <Flex
        width={1}
        flexDirection="column"
        justifyContent="left"
        alignContent="center"
        style={{ display: "grid" }}
      >
        <Box>
          {getLocalizedString("Linea")}:{" "}
          <OrderDetailText>
            {configuration
              ?.filter?.((f) => f.typeId == order?.orderTypeId)?.[0]
              ?.configuration?.filter((f) => f.line == line)[0]
              ?.lineDescription?.[lang] || ""}{" "}
          </OrderDetailText>
        </Box>
        <Box>
          {getLocalizedString("Collezione")}:{" "}
          <OrderDetailText>{collection}</OrderDetailText>
        </Box>
      </Flex>
    </Flex>
  );
};

export default OrderDetailInfo;
